import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Toolbar from "../../../components/toolbar/Toolbar";
import { Column } from "primereact/column";
import { routes } from "../../../constants";
import { Page } from "../../../components/page/Page";
import { TowerObservationTypeList } from "./TowerObservationTypeList";
import { actions } from "../tower_towerobservationtype.actions";
import { AppService, COMPANY_CHANGE_EVENT_NAME, BUSINESS_UNIT_CHANGE_EVENT_NAME } from "../../../services/app.service";
import moment from "moment";

const mapStateToProps = (state) => {
  return {
    columns: state.crudTowerObservationTypeState.columns,
    records: state.crudTowerObservationTypeState.records,
    first: state.crudTowerObservationTypeState.index,
    rows: state.crudTowerObservationTypeState.max,
    totalRecords: state.crudTowerObservationTypeState.count,
    sortField: state.crudTowerObservationTypeState.sortField,
    order: state.crudTowerObservationTypeState.sortOrder,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.setType(null));
      dispatch(actions.applyFilter(filterParams));
    },
    load: () => {
      dispatch(actions.load());
    },
    setSelectedRecords: (selectedRecords) => {
      dispatch(actions.setSelectedRecords(selectedRecords));
    },
  };
};

class TowerObservationTypeListPageContainer extends React.Component {
  newHandler = () => {
    this.props.history.push(`${routes.PATH_TOWER_OBSERVATION_TYPE}/novo`);
  };

  componentDidMount() {
    this.props.load();
    AppService.on(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }
  componentWillUnmount() {
    AppService.off(COMPANY_CHANGE_EVENT_NAME, this);
    AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }

  onReceiveAppNotifications = (eventName, params) => {
    if (eventName === COMPANY_CHANGE_EVENT_NAME || eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME) {
      this.props.applyFilter([]);
    }
  };
  onPage = (e) => {
    this.props.paginate({
      max: e.rows,
      index: e.first,
    });
  };
  onSort = (e) => {
    this.props.sortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField,
    });
  };

  onFilter = (e) => {
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach((key) => {
      filters.push({
        campo: key,
        valor: e.filters[key].value,
        tipoFiltro: "CONTEM",
      });
    });
    this.props.applyFilter(filters);
  };

  onRowClick = (e) => {
    const oid = e && e.data && e.data.oid;
    if (oid) {
      this.props.history.push(`${routes.PATH_TOWER_OBSERVATION_TYPE}/${oid}`);
    }
  };

  render() {
    const header = (
      <div>
        <h1>Tipo de observações</h1>
        <hr className="lxSplitter"></hr>
        <div>
          <Toolbar onNew={this.newHandler} newButtonStyle="highlighted"></Toolbar>
        </div>
      </div>
    );

    const datetimeTemplate = (rowData, column) => {
      try {
        const createdAt = rowData.eventRecord.createdAt; //data da ultima entrega realizada
        let formattedDate = "";
        if (createdAt) {
          formattedDate = moment(createdAt).format("DD/MM/YYYY HH:mm:ss");
        }
        return (
          <div>
            <p style={{ textAlign: "center", color: "black" }}>{formattedDate}</p>
          </div>
        );
      } catch (error) {
        return <div></div>;
      }
    };

    const columns = this.props.columns.map((col) => {
      if (col.field === "eventRecord.createdAt") {
        return <Column {...col} key={col.field} body={datetimeTemplate} />;
      }
      return <Column {...col} key={col.field} />;
    });

    const content = (
      <TowerObservationTypeList
        {...this.props}
        onRowClick={this.onRowClick}
        onFilter={this.onFilter}
        onPage={this.onPage}
        onSort={this.onSort}
        columns={columns}
      />
    );
    return <Page header={header} content={content} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TowerObservationTypeListPageContainer);
